import { UserBlog } from '@/model/data-object/UserBlog'
import { UserInterface } from '@/model/data-object/UserInterface'

export abstract class AbstractUser implements UserInterface {
  id = 0
  nickname = ''
  profileLink = ''
  blog: UserBlog = new UserBlog()
  isSubscriptionPremium = false
  isShowPremium = false
}
